<template>
  <ValidationProvider
    v-slot="{ errors, validate }"
    :disabled="!isItemBeingCreated"
    :rules="{ required: { allowFalse: false } }"
  >
    <NotificationInPage
      :notification="messageConfig"
      showNotification
    >
      <template #message>
        <ParagraphBody>
          Conditional Access Policies are only evaluated for LDAP applications that
          are targeted to the following URL: <strong>{{ ldapUrl }}</strong>
        </ParagraphBody>

        <Checkbox
          v-if="isItemBeingCreated"
          :class="$style.checkbox"
          :label="checkboxLabel"
          :value="isChecked"
          @input="() => toggleChecked(validate)"
        />

        <span
          v-if="errors.length"
          :class="$style.error"
        >
          {{ errors[0] }}
        </span>
      </template>
    </NotificationInPage>
  </ValidationProvider>
</template>

<script>
import {
  Checkbox,
  NotificationInPage,
  ParagraphBody,
  Types,
} from '@jumpcloud/ui-components';
import { ValidationProvider } from 'vee-validate3';
import { getLdapUrl } from 'client/Security/utils/AuthnPolicyUtilities';

const { NotificationConfig } = Types;

export default {
  name: 'LdapHostnameNotification',

  components: {
    Checkbox,
    NotificationInPage,
    ParagraphBody,
    ValidationProvider,
  },

  props: {
    isItemBeingCreated: {
      type: Boolean,
      required: true,
    },
  },

  data() {
    return {
      isChecked: false,
      messageConfig: new NotificationConfig({
        icon: 'info',
        showCloseButton: false,
        type: 'informational',
      }),
    };
  },

  computed: {
    checkboxLabel() {
      return 'I have updated the LDAP hostname for applications I want affected by this policy';
    },

    ldapUrl() {
      return getLdapUrl();
    },
  },

  methods: {
    async toggleChecked(validator) {
      this.isChecked = !this.isChecked;
      await validator(this.isChecked);
    },
  },
};
</script>

<style module>
.checkbox {
  display: inline-block;
}

.error {
  color: var(--jcError900);
  display: block;
  font-size: var(--jcBody);
  margin-left: 1.5em;
}
</style>
